export const TOGGLE_SNACKBAR_VISIBILITY = 'TOGGLE_SNACKBAR_VISIBILITY';
export type TOGGLE_SNACKBAR_VISIBILITY = typeof TOGGLE_SNACKBAR_VISIBILITY;


// WEBPACK FOOTER //
// ./src/store/SnackBarPopup/constants.ts